import React from 'react';
import ReasonCard from './ReasonCard';

const reasons = [
  {
    key: '1',
    title: 'Lorem ipsum dolor',
    subtitle: 'Lorem ipsum dolor',
    img: '/img/placeholder-1.png',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    key: '2',
    title: 'Lorem ipsum dolor',
    subtitle: 'Lorem ipsum dolor',
    img: '/img/placeholder-1.png',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    key: '3',
    title: 'Lorem ipsum dolor',
    subtitle: 'Lorem ipsum dolor',
    img: '/img/placeholder-1.png',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
];

export default function Reason() {
  return (
    <div className="mt-24 bg-transparent z-10 flex flex-col p-12">
      <div className="max-w-3xl mx-auto">
        <div className="w-16 h-2 bg-cyan" />
        <h2 className="font-bold text-gray-600 text-5xl text-center">
          Why should you apply?
        </h2>
        <p className="font-light text-black text-lg text-center mt-2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          <br />
          sed do eiusmod tempor incididunt
        </p>
      </div>
      <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-x-12 gap-y-12">
        {reasons.map((reason) => (
          <ReasonCard key={reason.key} {...reason} />
        ))}
      </div>
    </div>
  );
}
